import React from "react";
import { getWorkflowApprovalLabel, isActionBlockedForManagerView } from "../Constant/EmployeeActions.config";
import ReusableDropdown from "../../../components/ReusableDropdown";

const CustomActionDropdown = ({
  t,
  theme,
  selectedAction,
  setSelectedAction,
  setErrorMsg,
  isAdminView,
  isAdminRole,
  hasFeatureAccess,
  ACTION_TYPES,
  ACTION_FEATURE_MAP,
  workflowDefinitions,
  language,
  departmentName,
}) => {
  const availableActions = ACTION_TYPES.filter((action) => {
    // Manager view: salary changes are admin / admin-level only.
    if (isActionBlockedForManagerView(action.id, { isAdminView, isAdminRole })) return false;
    if (!isAdminView || isAdminRole || !hasFeatureAccess) return true;
    const featureKey = ACTION_FEATURE_MAP[action.id] || null;
    if (!featureKey) return true;
    // hasFeatureAccess does the canonical, alias-aware lookup — the
    // old hand-rolled check here only ever read the exact
    // "changesPage" property/module spelling and silently hid any
    // granted action that didn't match that exact casing.
    return hasFeatureAccess("changesPage", featureKey);
  });

  const mutedColor = theme === "dark" ? "#94a3b8" : "#64748b";

  return (
    <ReusableDropdown
      items={availableActions}
      value={selectedAction || ""}
      onChange={(actionId) => {
        setSelectedAction(actionId);
        setErrorMsg("");
      }}
      placeholder={t.selectActionType}
      getItemKey={(action) => action.id}
      getItemLabel={(action) => t[action.labelKey]}
      searchable={availableActions.length > 7}
      theme={theme}
      language={language}
      dropdownStyle={{ maxHeight: "380px" }}
      inputStyle={{ minHeight: "50px", fontSize: "15px", fontWeight: 600 }}
      renderItem={(action) => {
        const ItemIcon = action.icon;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "10px",
                background: action.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <ItemIcon size={18} color="white" />
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: "14px" }}>{t[action.labelKey]}</div>
              <div style={{ fontSize: "12.5px", color: mutedColor, fontWeight: 500, marginTop: "2px" }}>
                {t[action.descriptionKey]}
              </div>
              <div style={{ fontSize: "11.5px", color: mutedColor, fontWeight: 500, marginTop: "2px", opacity: 0.85 }}>
                {getWorkflowApprovalLabel(
                  action.id,
                  workflowDefinitions,
                  language,
                  t,
                  action.approvalLevelKey,
                  departmentName
                )}
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

export default CustomActionDropdown;
